import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import { useEffect, useState } from "react"
import { ILandingFloat } from "../../data/interfaces"

/* Protopia Ecosystem component */
export interface IFloatsScalarProps  extends ICompositeWidgetProps {
   
}
const FloatScalar = (props: IFloatsScalarProps): JSX.Element => {
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            subtitle={props.title}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <FloatEnabled {...props} /> }  
            desabledForm={ <FloatDisable {...props} /> }   
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
        />
    </>
}
export default FloatScalar

export const FloatEnabled = (props: IFloatsScalarProps): JSX.Element => {
    const [value, setValue] = useState<ILandingFloat[]>( 
            props.value || 
            props.default || 
            []
        )
    
        useEffect(() => {
            setValue( props.value )
        }, [ props.value ])
    
        const onChange = ( _value: ILandingFloat[], field: string ="", dop: any = {} ) => { 
            if(props.onChange) {
            props.onChange( _value, props.field, "" )
        }  
        }  
        return <div className="w-100 pl-1 pr-4 mr-2 d-flex flex-column flex-wrap"> 
            {value.length}
        </div>
}

export const FloatDisable = (props: IFloatsScalarProps): JSX.Element => {
    return <></>
}